/**
 * Funzione che ritorna il valore salvato in sessione
 * @param {*} name
 */
const getStoredSessionItem = (name) => window.sessionStorage.getItem(name);

/**
 * Metodo utilizzato per salvare un valore in session
 * @param {*} name
 * @param {*} value
 */
const setStoredSessionItem = (name, value) => {
  window.sessionStorage.setItem(name, value);
};

export {
  getStoredSessionItem,
  setStoredSessionItem,
};
